import type {
  DesktopPlatform,
  DownloadChannel,
  DownloadManifest,
  ExtensionManifest
} from '../../shared-types/src/index.js';
import type { ServiceApi } from '../../service-api/src/service.js';
import type { ServiceTokenClaims } from '../../service-api/src/tokens.js';
import type { ServiceClient } from './index.js';

type DownloadsApi = Pick<
  ServiceApi,
  'downloadChannels' | 'downloadLatest' | 'extensionLatest'
>;
type InProcessDownloads = Pick<
  ServiceClient,
  'downloadChannels' | 'downloadLatest' | 'extensionLatest'
>;
interface InProcessDownloadsDeps {
  api: () => DownloadsApi;
  verify: (accessToken: string) => Promise<ServiceTokenClaims>;
}

export function createInProcessDownloads(
  deps: InProcessDownloadsDeps
): InProcessDownloads {
  return {
    async downloadChannels(accessToken: string): Promise<DownloadChannel[]> {
      const { tenantId, userId } = await deps.verify(accessToken);
      return deps.api().downloadChannels(tenantId, userId);
    },

    async downloadLatest(
      accessToken: string,
      channel: DownloadChannel,
      platform: DesktopPlatform
    ): Promise<DownloadManifest> {
      const { tenantId, userId } = await deps.verify(accessToken);
      return deps.api().downloadLatest(tenantId, userId, channel, platform);
    },

    async extensionLatest(
      accessToken: string,
      extensionId: string,
      platform: 'win32' | 'darwin',
      request: { appVersion: string; protocolVersion: number }
    ): Promise<ExtensionManifest> {
      const { tenantId, userId } = await deps.verify(accessToken);
      return deps
        .api()
        .extensionLatest(tenantId, userId, extensionId, platform, request);
    }
  };
}
